module.exports = __webpack_public_path__ + "img/geoportal-blue.7106ac40.png";